import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const getUserProfileKitsWanted = async ({ uid }) => {
	try {
		const userProfileDocRef = firestore.collection('userProfiles').doc(uid)

		const kitsWantedQuerySnap = await userProfileDocRef.collection('kitsWanted')
			.orderBy('createdTimestamp', 'desc')
			.get()

		const kitsWanted = kitsWantedQuerySnap.docs.map(d => d.data())
		return kitsWanted
	} catch (error) {
		throw errorOfType(errorTypes.UNKNOWNERROR, uid, error)
	}
}

export default getUserProfileKitsWanted



// WEBPACK FOOTER //
// ./src/dataservices/getUserProfileKitsWanted.js